const AUTH_CONSTANTS = {
    LOGIN_ROUTE_ORIGIN: "normal",
};

export { AUTH_CONSTANTS };
